export const getCollection = '/collections';
export const addCollection = '/collections/add-collection';
export const updateCollection = '/collections/';
export const updateCollectionStatus = '/Collections/update-status/';
export const deleteCollection = '/collections/';
